/// 一括営業チャネル除外の派生レスポンス (spec 20260716「API Semantics」)。
///
/// backend の共通合成判定 (本人 5 フラグ / 現所属事務所 5 フラグ / 懲戒 stop_contact の
/// OR 合成) の出力を描画するための型。frontend は合成を再実装せず、この派生値だけを
/// 表示に使う (詳細・通常一覧・所属弁護士一覧の判定一致)。保存値 (5 boolean) とは別物。

/// 固定 5 チャネル (仕様書の固定順)。
export const BULK_SALES_CHANNELS = ['email', 'phone', 'fax', 'postal_dm', 'sms'] as const;
export type BulkSalesChannel = (typeof BULK_SALES_CHANNELS)[number];

/// 3 値: 対象 / 一部対象外 / 対象外。
export type BulkSalesTargetState = 'target' | 'partially_excluded' | 'excluded';

/// 除外の由来。
export type BulkSalesExclusionSource = 'lawyer' | 'firm' | 'disciplinary';

/// 連絡経路 (帰属付き)。
export type BulkSalesContactRoute =
  | 'lawyer_emails'
  | 'lawyer_direct_line'
  | 'firm_email'
  | 'firm_phone'
  | 'firm_fax'
  | 'firm_address';
export type BulkSalesRouteOwner = 'lawyer' | 'firm';

export interface BulkSalesRouteDecision {
  route: BulkSalesContactRoute;
  owner: BulkSalesRouteOwner;
  excluded: boolean;
  sources: BulkSalesExclusionSource[];
}

export interface BulkSalesChannelDecision {
  state: BulkSalesTargetState;
  sources: BulkSalesExclusionSource[];
  routes: BulkSalesRouteDecision[];
}

/// 弁護士 1 人分の派生値 (本人 / 事務所 / 懲戒の OR 合成)。
export interface LawyerBulkSalesDecision {
  state: BulkSalesTargetState;
  channels: Record<BulkSalesChannel, BulkSalesChannelDecision>;
}

/// 法律事務所単体の派生値 (事務所 5 フラグのみから導出)。
export interface FirmBulkSalesDecision {
  state: BulkSalesTargetState;
  excluded_channels: BulkSalesChannel[];
}

/// 保存値 5 boolean のキー (lawyers / firms 共通の列名)。
export const BULK_SALES_FLAG_KEYS = {
  email: 'bulk_sales_email_excluded',
  phone: 'bulk_sales_phone_excluded',
  fax: 'bulk_sales_fax_excluded',
  postal_dm: 'bulk_sales_postal_dm_excluded',
  sms: 'bulk_sales_sms_excluded',
} as const satisfies Record<BulkSalesChannel, string>;
export type BulkSalesFlagKey = (typeof BULK_SALES_FLAG_KEYS)[BulkSalesChannel];

/// 保存値 5 boolean (lawyer / firm のレコードから取り出した部分)。
export type BulkSalesFlags = Record<BulkSalesFlagKey, boolean>;
